<template>
    <svg width="29" height="25" viewBox="0 0 29 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.5 0L28.7894 24.75L0.210581 24.75L14.5 0Z" fill="currentColor"/>
    </svg>
</template>